/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Helmet } from "react-helmet"

import Header from "./header"
import Footer from "./footer"
import "./layout.css"

import OGimage from '../images/Open Graph Image.jpg'

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no"
        />
        <meta property="og:image" content="https://sigchi.org/static/Open%20Graph%20Image-c8e6613cedecec3e01c3b10fcde2f2ff.jpg" />
        <meta property="og:image:secure" content="https://sigchi.org/static/Open%20Graph%20Image-c8e6613cedecec3e01c3b10fcde2f2ff.jpg" />
        <meta property="og:image:secure_url" content="https://sigchi.org/static/Open%20Graph%20Image-c8e6613cedecec3e01c3b10fcde2f2ff.jpg" />
        <meta property="og:image:width" content="400" />
        <meta property="og:image:height" content="300" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link href="https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,wght@0,400;0,500;0,700;1,400;1,500&family=DM+Sans:ital,wght@0,400;0,500;0,700;1,400;1,500&family=Inter:wght@200;400;500;600;700&display=swap" rel="stylesheet" />
      </Helmet>
      <Header siteTitle={data.site.siteMetadata?.title || `SIGCHI`} />
      <main>{children}</main>
      <Footer />
    </>
  )
}

export default Layout
